import React from "react";
import Slider from "react-slick";
import { Box, Typography, Button, Chip, Stack } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ad1 from "../assests/ad/ad1.jpg";
import ad2 from "../assests/ad/ad2.jpg";
import ad3 from "../assests/ad/ad3.jpg";

const ads = [
  {
    id: 1,
    title: "🩺 24x7 Emergency Services",
    description:
      "Round-the-clock emergency care with advanced life support systems and a skilled trauma team.",
    tags: ["24/7 Care", "Ambulance", "Emergency ICU"],
    bullets: [
      "Advanced Trauma Life Support (ATLS)",
      "Quick response ambulance team",
      "Specialized emergency doctors",
    ],
    image: ad1,
  },
  {
    id: 2,
    title: "🏥 World-Class Surgery Center",
    description:
      "High-tech operating rooms and renowned surgeons ensure the best care during procedures.",
    tags: ["Operation Theatres", "Expert Surgeons", "Minimal Invasive"],
    bullets: [
      "Equipped with AI-supported surgical tools",
      "Renowned national & international surgeons",
      "Pre & post-operative care team",
    ],
    image: ad3,
  },
  {
    id: 3,
    title: "🧬 Full Body Health Checkups",
    description:
      "Affordable and comprehensive preventive health packages for the whole family.",
    tags: ["Affordable", "Preventive Care", "Reports in 24hr"],
    bullets: [
      "Includes 70+ essential tests",
      "Diet & lifestyle consultation",
      "Family-friendly packages",
    ],
    image: ad2,
  },
];

const HospitalAdCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 1800,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        mx: "auto",
        mt: 2,
        px: 2,
        height: "300px",
      }}
    >
      <Slider {...settings}>
        {ads.map((ad, index) => {
          const isEven = index % 2 === 1;

          return (
            <Box
              key={ad.id}
              sx={{
                display: "flex !important",
                flexDirection: isEven ? "row-reverse" : "row",
                backgroundColor: "#ffffff",
                borderRadius: 3,
                boxShadow: 3,
                overflow: "hidden",
                height: 340,
              }}
            >
              {/* Image */}
              <Box sx={{ width: "50%", height: "100%" }}>
                <img
                  src={ad.image}
                  alt={ad.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>

              {/* Text Section */}
              <Box
                sx={{
                  width: "50%",
                  p: 3,
                  backgroundColor: "#f4f7fb",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  textAlign: isEven ? "right" : "left",
                }}
              >
                <Box>
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    color="primary"
                    gutterBottom
                  >
                    {ad.title}
                  </Typography>

                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ mb: 1 }}
                  >
                    {ad.description}
                  </Typography>

                  {/* Tags */}
                  <Stack
                    direction="row"
                    spacing={1}
                    justifyContent={isEven ? "flex-end" : "flex-start"}
                    flexWrap="wrap"
                    mb={1.5}
                  >
                    {ad.tags.map((tag, idx) => (
                      <Chip
                        key={idx}
                        label={tag}
                        color="secondary"
                        size="small"
                      />
                    ))}
                  </Stack>

                  {/* Bullet Points */}
                  <Stack spacing={1}>
                    {ad.bullets.map((point, idx) => (
                      <Stack
                        key={idx}
                        direction="row"
                        alignItems="center"
                        justifyContent={isEven ? "flex-end" : "flex-start"}
                        spacing={1}
                      >
                        {!isEven && (
                          <CheckCircleIcon color="primary" fontSize="small" />
                        )}
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ maxWidth: "90%" }}
                        >
                          {point}
                        </Typography>
                        {isEven && (
                          <CheckCircleIcon color="primary" fontSize="small" />
                        )}
                      </Stack>
                    ))}
                  </Stack>
                </Box>

                {/* CTA Button */}
                <Box
                  sx={{
                    mt: 2,
                    display: "flex",
                    justifyContent: isEven ? "flex-end" : "flex-start",
                  }}
                >
                  <Button variant="contained" size="small">
                    Learn More
                  </Button>
                </Box>
              </Box>
            </Box>
          );
        })}
      </Slider>
    </Box>
  );
};

export default HospitalAdCarousel;
